import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';

export const separators: tCaseComponentsLib = [
    {
        id: 'tcd_900',
        xmlId: '6b422e88-0248-f8e9-36d4-78147ebe8b62',
        name: 'TC перегородка вертикальная TCD-900',
        type: 'separator',
        caseModels: [ 'TC-1095', 'TC-1995-2' ],
        blenderName: 'ver_wall_tcd_900',
        image: 'dist/src/img/tcd_900.png',
    },
    {
        id: 'tcd_1800_2',
        xmlId: '20c707f2-f292-9a23-2bbe-2ca2d1727b70',
        name: 'TC перегородка вертикальная TCD-1800/2',
        type: 'separatorT',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'ver_wall_tcd_1800_2',
        image: 'dist/src/img/tcd_1800_2.png',
    },
    {
        id: 'tcd_1800',
        xmlId: 'd0a1236b-b509-27e9-f0da-e144767810fb',
        name: 'TC перегородка вертикальная TCD-1800',
        type: 'separator',
        caseModels: [ 'TC-1995' ],
        blenderName: 'ver_wall_tcd_1800',
        image: 'dist/src/img/tcd_1800.png',
    },
];
